// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + "store" + "." + "2c9e26c4" + ".chunk.js");